import { VerifyAuthResponse } from '@common/api/authService';
import { useUserStorage } from '@common/hooks/useUserStorage';
import { useEffect, useState } from 'react';

export const HAS_SHOW_ONBOARDING = 'HAS_SHOW_ONBOARDING';

interface UseOnboardingReturn {
    isOnboardingOpen: boolean;
    openOnboarding: () => void;
    closeOnboarding: () => void;
}

export const useOnboarding = (
    profile: VerifyAuthResponse | null,
    isLoadingProfile: boolean
): UseOnboardingReturn => {
    const [isOnboardingOpen, setIsOnboardingOpen] = useState(false);
    const {get, set} = useUserStorage();

    const openOnboarding = () => {
        setIsOnboardingOpen(true);
        // Mark as shown when user closes onboarding
        set(HAS_SHOW_ONBOARDING, true);
    };

    const closeOnboarding = () => {
        setIsOnboardingOpen(false);
    };
    useEffect(() => {
        // Check if user has already seen onboarding
        const hasShowOnboarding = get(HAS_SHOW_ONBOARDING);
        if (hasShowOnboarding) {
            closeOnboarding();
        }else{
            openOnboarding();
        }
    }, [])

    // Check if onboarding should be shown
    useEffect(() => {
        // 未登录
        if(!isLoadingProfile && !profile){
            closeOnboarding();
            return;
        }
        // 已登录，已onboarding
        if (!isLoadingProfile && profile?.shopInfos?.length) {
            closeOnboarding();
            return;
        }else if(!isLoadingProfile && !profile?.shopInfos?.length){  // 已登录，未onboarding
            openOnboarding();
            return;
        }
    }, [profile, isLoadingProfile]);

    return {
        isOnboardingOpen,
        openOnboarding,
        closeOnboarding
    };
};